import axiosInstance from './axiosInstance';

const API_URL = process.env.REACT_APP_API_URL;
const RESOURCE = 'task-cycle-groups';

export const getTaskCycleGroups = async () => {
  try {
    const response = await axiosInstance.get(`${API_URL}/${RESOURCE}`);
    return response.data;
  } catch (error) {
    console.error('Error fetching task cycle groups:', error.response?.data || error);
    throw error;
  }
};

export const getTaskCycleGroupById = async (id) => {
  try {
    const response = await axiosInstance.get(`${API_URL}/${RESOURCE}/${id}`);
    return response.data;
  } catch (error) {
    console.error('Error fetching task cycle group:', error.response?.data || error);
    throw error;
  }
};

export const createTaskCycleGroup = async (data) => {
  try {
    const response = await axiosInstance.post(`${API_URL}/${RESOURCE}`, data);
    return response.data;
  } catch (error) {
    console.error('Error creating task cycle group:', error.response?.data || error);
    throw error;
  }
};

export const updateTaskCycleGroup = async (id, data) => {
  try {
    const response = await axiosInstance.put(`${API_URL}/${RESOURCE}/${id}`, data);
    return response.data;
  } catch (error) {
    console.error('Error updating task cycle group:', error.response?.data || error);
    throw error;
  }
};

export const deleteTaskCycleGroup = async (id) => {
  try {
    const response = await axiosInstance.delete(`${API_URL}/${RESOURCE}/${id}`);
    return response.data;
  } catch (error) {
    console.error('Error deleting task cycle group:', error.response?.data || error);
    throw error;
  }
};
